module.exports = "html {\n    /* Size of largest container or bigger */\n    min-width: 1250px;\n    max-width: 1250px;\n    \n}"